import React, { Component } from "react";
import { Button, Modal, Input, message } from "antd";
import { stringify } from "qs";
import router from "umi/router";
import FilesUpload from "nbugs-files-upload";
import { connect } from "dva";
import Container from "@/components/Container";
import { ENV } from "@/services/utils";
import { GetQueryString } from "@/utils/utils";
import ListPage from "@/components/ListPage";
import OperateDropdown from "@/components/OperateDropdown";
import styles from "./index.less";

const { Search } = Input;
const { ListTable } = ListPage;

@connect(({ myEvaluation }) => ({
  evaluationTargetList: myEvaluation.evaluationTargetList,
  spinProps: myEvaluation.spinProps,
  pageInfo: myEvaluation.pageInfo,
  allowEdit: myEvaluation.allowEdit
}))
class MyEvaluation extends Component {
  constructor(props) {
    super(props);

    const columns = [
      {
        title: "评价对象",
        dataIndex: "name"
      },
      {
        title: "自评分数",
        dataIndex: "score"
      },
      {
        title: "评价进度",
        dataIndex: "progress"
      },
      {
        title: "操作",
        dataIndex: "",
        render: record => {
          const data = [
            {
              text: (
                <a onClick={event => this.handleClickCheck({ record, event })}>
                  自评报告
                </a>
              )
            }
          ];
          return <OperateDropdown data={data} />;
        }
      }
    ];

    const currentProjectId = GetQueryString("currentProjectId");

    this.state = {
      columns,
      currentProjectId,
      showAppendixModal: false,
      currentAppendix: "",
      searchName: ""
    };
  }

  componentDidMount() {
    this.getList();
  }

  // 分页改变
  handlePaginationChange = (page, pageSize) => {
    const pageInfo = { page, pageSize };
    this.getList(pageInfo);
  };

  getList = pageInfo => {
    const { currentProjectId, searchName } = this.state;
    const { dispatch } = this.props;
    dispatch({
      type: "myEvaluation/fetchSelfList",
      payload: {
        projectId: currentProjectId,
        name: searchName,
        page: 1,
        pageSize: 10,
        ...pageInfo
      }
    });
  };

  handleModal = () => {
    this.setState({
      showAppendixModal: false
    });
  };

  handleClickCheck = ({ record, event }) => {
    if (event) {
      event.stopPropagation();
    }
    const { appendix } = record;
    // 查看自评报告
    this.setState({
      showAppendixModal: true,
      currentAppendix: appendix
    });
  };

  handleStart = () => {
    // 开始评估
    const { currentProjectId } = this.state;
    const { match, allowEdit } = this.props
    const { path } = match
    if(!allowEdit) {
      message.error('不在评估时间')
    } else {
      router.push(
        `${path}/tree?${stringify({
          currentProjectId
        })}`
      );
    }
  };

  handleSearch = val => {
    this.setState(
      {
        searchName: val
      },
      () => {
        this.getList();
      }
    );
  };

  renderHeader = () => {
    return (
      <div className="header">
        <div className="btn-wrap">
          <Button type="primary" onClick={this.handleStart}>
            开始评价
          </Button>
        </div>
        <Search
          style={{ width: 300 }}
          placeholder="请输入评价对象名称"
          onSearch={this.handleSearch}
        />
      </div>
    );
  };

  render() {
    const { showAppendixModal, currentAppendix, columns } = this.state;

    const { spinProps, evaluationTargetList, pageInfo } = this.props;

    const containerProps = {
      breStates: true,
      version: 2,
      isPathParams: true
    };

    const pageProps = {
      spinProps,
      className: styles.myEvaluation
    };

    const tableProps = {
      columns,
      rowKey: "id",
      list: evaluationTargetList,
      pageInfo,
      onPageChange: this.handlePaginationChange
    };

    return (
      <Container {...containerProps}>
        <ListPage {...pageProps}>
          <div className="container">
            {this.renderHeader()}
            <ListTable {...tableProps} />
          </div>
          {showAppendixModal && (
            <Modal
              visible
              centered
              title="自评报告"
              onOk={this.handleModal}
              onCancel={this.handleModal}
            >
              {currentAppendix ? (
                <FilesUpload
                  edit={1}
                  type="pc"
                  APIEnv={ENV}
                  groupId={currentAppendix}
                  key={Date.now()}
                />
              ) : (
                "暂无数据"
              )}
            </Modal>
          )}
        </ListPage>
      </Container>
    );
  }
}

export default MyEvaluation;
